import { render, staticRenderFns } from "./eBayChannelTextOnly.vue?vue&type=template&id=3873c78a&scoped=true"
import script from "./eBayChannelTextOnly.vue?vue&type=script&lang=js"
export * from "./eBayChannelTextOnly.vue?vue&type=script&lang=js"
import style0 from "./eBayChannelTextOnly.vue?vue&type=style&index=0&id=3873c78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873c78a",
  null
  
)

export default component.exports